// import $ from "jquery";
// import validate from "jquery-validation";
// import './jquery-validate-extra-rules';
import { stringToHTML } from './utils';

let formElement;

const FORM_TIME_START = Math.floor((new Date).getTime()/1000);

export function init() {
    // const submitBtn = document.querySelector('.js-enquiries-submit'),
    //     results = document.querySelector('.js-enquiries-results'),
    //     rules = {
    //         'first_name': {
    //             required    : true,
    //             minlength   : 2
    //         },
    //         'last_name': {
    //             required    : true,
    //             minlength   : 2
    //         },
    //         'email_address': {
    //             required    : true,
    //             email       : true
    //         },
    //         'telephone_number': {
    //             required: true,
    //             digitsandspaces: true,
    //             minlength: 8,
    //             maxlength: 18
    //         },
    //         'location': {
    //             required    : true,
    //             minlength   : 2
    //         },
    //         'consent': {
    //             required    : true
    //         }
    //     },
    //     messages = {
    //         'first_name': {
    //             required    : 'Please provide your first name',
    //             minlength   : 'Please provide your full first name'
    //         },
    //         'last_name': {
    //             required    : 'Please provide your last name',
    //             minlength   : 'Please provide your full last name'
    //         },
    //         'email_address': {
    //             required    : 'Please provide your email address',
    //             email       : 'Please provide a valid email address'
    //         },
    //         'telephone_number': {
    //             required: 'Please provide your telephone number',
    //             digitsandspaces: 'Please enter only numbers and spaces',
    //             minlength: 'Please enter a valid telephone number (8-18 characters)',
    //             maxlength: 'Please enter a valid telephone number (8-18 characters)'
    //         },
    //         'location': {
    //             required    : 'Please provide your location (town/city and country)',
    //             minlength   : 'Please provide more detail about your location'
    //         },
    //         'consent': {
    //             required    : 'You must give consent for WEC to store your details in order to connect with you about relevant opportunities'
    //         }
    //     };
        
    // // Setup form validation and submision events
    // $('.js-enquiries').validate({
    //     rules           : rules,
    //     messages        : messages,
    //     errorPlacement: function($error, $el) {
    //         // If this is a checkbox
    //         if ($el.is('[type=checkbox]')) {
    //             // Check for a group container
    //             var $checkboxGroupContainer = $el.closest('.js-checkbox-container');

    //             if ($checkboxGroupContainer.length) {
    //                 return $checkboxGroupContainer.append($error);
    //             }
    //         }

    //         return $error.insertAfter($el);
    //     },
    //     submitHandler: function (form) {
    //         console.log('here');
    //         // Update submit button text
    //         submitBtn.classList.add('sending');
    //         submitBtn.value = 'Connecting...';

    //         const formData = new FormData(form);

    //         fetch(form.action, {
    //             method: 'POST',
    //             headers: { 
    //                 "X-Requested-With": "XMLHttpRequest" 
    //             },
    //             body: formData
    //         })
    //         .then(response => response.json())
    //         .then(data => {
    //             if (data) {
    //                 if (data.status == 'success') {
    //                     form.querySelectorAll('input:not([type="checkbox"]):not([type="submit"]), textarea').forEach(el => {
    //                         el.value = '';
    //                     });

    //                     submitBtn.classList.remove('sent');
    //                     submitBtn.value = 'Connected!';

    //                     // Fire an event off to Google Analytics to track this form submission
    //                     if (typeof ga !== "undefined") {
    //                         ga('send', {
    //                             hitType: 'event',
    //                             eventCategory: 'Enquiries Form',
    //                             eventAction: 'Send Connect Request',
    //                             eventLabel: form.querySelector('select').value.split('|')[1]
    //                         });
    //                     }
    //                 } else {
    //                     submitBtn.classList.remove('sending');
    //                     submitBtn.value = 'Connect';
    //                 }

    //                 results.innerHTML = data.message;
    //                 results.classList.add(data.status);
    //             } else {
    //                 results.innerHTML = '<p>Sorry there was a problem submitting the enquiry, please try again.</p>';
    //                 submitBtn.classList.remove('sending');
    //                 submitBtn.value = 'Connect';
    //             }
    //         });
    //     }
    // });

    formElement = document.querySelector('.js-enquiries');

    if (formElement) {            
        formElement.addEventListener('submit', formSubmit, false);
    }
}

function formSubmit(e) {
    e.preventDefault();
    console.log('submitting...');

    appendJsTimerElement();

    // If there are any errors, don't submit
    if (formElement.querySelectorAll('.errFld').length) {
        return false;
    }

    // Fire an event off to Google Analytics to track this form submission
    if (typeof ga !== "undefined") {
        ga('send', {
            hitType: 'event',
            eventCategory: 'Enquiries Form',
            eventAction: 'Send Connect Request',
            eventLabel: formElement.querySelector('select.js-area-of-interest').value
        });
    }

    if (window.fetch) {
        const results = document.querySelector('.js-enquiries-results');
        const formData = new FormData(formElement);

        fetch(formElement.action, {
            method: 'POST',
            body: formData
        })
            .then(response => response.text())
            .then(data => {
                // Parse string response as HTML
                let responseHTML = stringToHTML(data);
            
                // Pull out contents of .wForm and insert into .result Node
                if (responseHTML.querySelector('.wForm')) {
                    if (responseHTML.querySelector('.wForm .wFormThankYou')) {
                        results.classList.add('success');
                        results.classList.remove('error');

                        // Reset form
                        formElement.reset();
                    } else {
                        results.classList.remove('success');
                        results.classList.add('error');
                    }

                    results.innerHTML = responseHTML.querySelector('.wForm').innerHTML;
                }
            });
    } else {
        // Submit form normally - directing user to FormAssembly site
        formElement.submit();
    }
}

function appendJsTimerElement() { 
    let formTimeDiff = Math.floor((new Date).getTime()/1000) - FORM_TIME_START;
    let cumulatedTimeElement = document.getElementById("tfa_dbCumulatedTime");

    if (null !== cumulatedTimeElement) {
        let cumulatedTime = parseInt(cumulatedTimeElement.value);

        if (null !== cumulatedTime && cumulatedTime > 0) {
            formTimeDiff += cumulatedTime;
        }
    }

    let jsTimeInput = document.createElement("input");

    jsTimeInput.setAttribute("type", "hidden");
    jsTimeInput.setAttribute("value", formTimeDiff.toString());
    jsTimeInput.setAttribute("name", "tfa_dbElapsedJsTime");
    jsTimeInput.setAttribute("id", "tfa_dbElapsedJsTime");
    jsTimeInput.setAttribute("autocomplete", "off");
    
    formElement.appendChild(jsTimeInput);
};